import PropTypes from 'prop-types';
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (this.props.setErrorFlag) this.props.setErrorFlag(!!error);
  }

  componentWillUnmount() {
    if (this.props.setErrorFlag) this.props.setErrorFlag(false);
  }

  render() {
    if (this.state.error) {
      return this.props.fallbackUI;
    }
    return this.props.children;
  }
}

ErrorBoundary.defaultProps = {
  fallbackUI: <div>Error while displaying the content</div>,
  setErrorFlag: () => {}
};

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallbackUI: PropTypes.node,
  setErrorFlag: PropTypes.func
};

export default ErrorBoundary;
